import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { Flex, Form } from 'antd'
import type { ReactNode } from 'react'
import { BulkAddTemplateInputs, type BulkAddTemplateOutput, type BulkAddTemplateForm as FormType } from './Inputs'

type Props = {
  initialValues?: FormType
  extraButtons?: ReactNode
  isPending?: boolean
  onSubmit?: (values: BulkAddTemplateOutput) => void
}

export function BulkAddTemplateForm({ initialValues, extraButtons, onSubmit, isPending }: Props) {
  const [form] = Form.useForm<FormType>()

  return (
    <Form
      form={form}
      onFinish={(values) => onSubmit?.(values as BulkAddTemplateOutput)}
      layout='vertical'
      initialValues={initialValues}
    >
      <BulkAddTemplateInputs.Driver />
      <BulkAddTemplateInputs.Template form={form} />
      <Horizontal gap={8}>
        <BulkAddTemplateInputs.StartDate form={form} />
        <BulkAddTemplateInputs.EndDate form={form} />
      </Horizontal>
      <Flex style={{ flexDirection: 'row-reverse', width: '100%' }} gap={6}>
        <GraviButton theme2 loading={isPending} htmlType='submit'>
          Generate Schedules
        </GraviButton>
        {extraButtons}
      </Flex>
    </Form>
  )
}
